import { useEffect, useState } from 'react';
import Pagination from '../../extra/Pagination';
import Table from '../../extra/Table';
// import Skeleton from 'react-loading-skeleton';
// import { colors } from "../../../util/SkeletonColor";
import { IconCopy } from "@tabler/icons-react";
import dayjs from "dayjs";
import Skeleton from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import defaultImage from "../../../assets/images/default.jpg";
import { colors } from "../../../util/SkeletonColor";
import DateRangeSelect from '../../extra/DateRangeSelect';
import formatImageUrl from '../../extra/functions';
import { getAdminEarning } from '../../store/redeem/redeem.action';
import { getSetting } from '../../store/setting/setting.action';



const AdminEarning = (props) => {

    const dispatch = useDispatch();

    const [size, setSize] = useState(10);
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sDate, setsDate] = useState("All");
    const [eDate, seteDate] = useState("All");

    const { adminEarning, adminTotalEarnings, total, loadingg } = useSelector((state) => state.redeem);
    const { setting } = useSelector((state) => state.setting);

    useEffect(() => {
        dispatch(getSetting());
        dispatch(getAdminEarning(currentPage, rowsPerPage, sDate, eDate));
    }, [currentPage, rowsPerPage, sDate, eDate]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);


    useEffect(() => {
        setData(adminEarning);
    }, [adminEarning])



    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setLoading(false);
    //     }, 1500); // Adjust the delay time as needed

    //     return () => clearTimeout(timer);
    // }, []);


    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event), 10);
        setSize(parseInt(event), 10);
        setCurrentPage(1);
    };

    const handleDateApply = (dayStart, dayEnd) => {
        setsDate(dayStart);
        seteDate(dayEnd);
        setCurrentPage(1);
    };

    const handleDateClear = () => {
        setsDate("All");
        seteDate("All");
        setCurrentPage(1);
    };

    const copyToClipboard = (Text) => {
        navigator.clipboard.writeText(Text);
        toast.success("Order ID copied to clipboard");
    };

    const mapData = [
        {
            Header: "No",
            width: "20px",
            Cell: ({ index }) =>
                <span className="text-white">
                    {(currentPage - 1) * rowsPerPage + index + 1}
                </span>,
        },

        {
            Header: "Order Id",
            body: "orderid",
            Cell: ({ row }) => (
                <span className="boxCenter text-white">

                    {row?.orderId ? row?.orderId : "-"}
                    <IconCopy
                        size={16}
                        className="ms-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => copyToClipboard(row?.orderId ? row?.orderId : "-")}
                    />
                </span>
            ),
        },

        {
            Header: "Product",
            accessor: "product", 
            Cell: ({ row }) => {
                let imageUrl = formatImageUrl(row?.productImage); 
                return (
                    <div className="d-flex" style={{ paddingLeft: "20px" }}>
                        <div className="position-relative">
                            <img
                                src={imageUrl}
                                style={{
                                    borderRadius: "90px",
                                    objectFit: "cover",
                                    boxSizing: "border-box",
                                }}
                                height={45}
                                width={45}
                                alt={row?.productName || "-"}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = defaultImage;
                                }}
                            />
                        </div>
                        <span className="boxCenter text-start ms-3 fw-normal text-white" style={{ paddingLeft: "10px" }}>
                            {row?.productName ? row?.productName : "-"}
                        </span>
                    </div>
                );
            },
        },

        {
            Header: `Seller Name`,
            body: "sellerName",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{row?.sellerName + " " + row?.lastName}</span>
            ),
        },

        {
            Header: `Business Name`,
            body: "businessName",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{row?.businessName}</span>
            ),
        },

        {
            Header: `Business Tag`,
            body: "businessTag",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{row?.businessTag}</span>
            ),
        },

        {
            Header: `Seller Earning (${setting?.currency?.symbol})`,
            body: "sellerEarning",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{setting?.currency?.symbol} {row?.amount} </span>
            ),
        },

        {
            Header: `Admin Earning (${setting?.currency?.symbol})`,
            body: "adminEarning",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{setting?.currency?.symbol} {row?.commissionPerProductQuantity} </span>
            ),
        },

        {
            Header: "Date and Time",
            body: "createdAt",
            Cell: ({ row }) => (
                <span className="text-white">{row.date}</span>
            ),
        },
    ];



    return (
        <div className="mainSellerTable">
            <div className="sellerTable">
                <div className="col-12 headname">Admin Earning</div>
                <div className="sellerMain">
                    <div className="tableMain mt-2">
                        <div className="sellerHeader primeHeader">
                            <div className="d-md-flex justify-content-between align-items-center">
                                <div className='col-12 col-md-6 text-center text-sm-start' style={{ fontWeight: "bold" }} >
                                    Total Admin Earning : {adminTotalEarnings} {setting?.currency?.symbol}
                                </div>
                                <div className="col-12 col-md-6 d-flex justify-content-center justify-content-sm-end">
                                    <div className="my-1 w-100 d-flex justify-content-center justify-content-sm-end">
                                        <DateRangeSelect
                                            startDate={sDate}
                                            endDate={eDate}
                                            onApply={handleDateApply}
                                            onClear={handleDateClear}
                                            placeholder="Select Date"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table
                            data={data}
                            mapData={mapData}
                            serverPerPage={rowsPerPage}
                            serverPage={page}
                            type={"server"}
                            loading={loading}
                            shimmer={true}
                        />
                        <Pagination
                            component="div"
                            count={total}
                            type={"server"}
                            onPageChange={handleChangePage}
                            serverPerPage={rowsPerPage}
                            totalData={total}
                            serverPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                <div className="sellerFooter primeFooter"></div>
            </div>
        </div>
    )
}

export default AdminEarning